module.exports = __webpack_public_path__ + "static/media/year2024_1-tc.cc86ddbb.jpg";